import * as React from 'react';
import { useSelector } from 'react-redux';
import { Section } from 'shared/components/Section';
import { SeoMarkedList } from 'shared/components/SeoMarkedList';
import { selectMarkedListItems } from 'shared/selectors/seoMarkedList';

export const SeoMarkedListContainer: React.FC = () => {
  const items = useSelector(selectMarkedListItems);

  if (!items.length) {
    return null;
  }

  return (
    <Section dataName="SeoMarkedListSection">
      <SeoMarkedList items={items} />
    </Section>
  );
};
